import { Table as PortfolioPagesTable } from '@/components/portfolio_pages/table'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-6">
        <PortfolioPagesTable updateable />
      </div>
    </>
  )
}
